(function($, Drupal) {
  Drupal.behaviors.jnjosBrandLogReactIsSmallMenu = {
    attach() {
      $('div[react-component="brand_logo"]').each(function() {
        let dataProps = $(this).attr('data-props');
        if (!dataProps) {
          return false;
        }
        dataProps = JSON.parse(dataProps);
        dataProps.isSmallMenu = !!$('.header-container .menu-version-small')
          .length;
        $(this).attr('data-props', JSON.stringify(dataProps));
        return dataProps;
      });
    },
  };
})(jQuery, Drupal);
